import { render, staticRenderFns } from "./OrderLaundryEdit.vue?vue&type=template&id=ff698a36&scoped=true"
import script from "./OrderLaundryEdit.vue?vue&type=script&lang=js"
export * from "./OrderLaundryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff698a36",
  null
  
)

export default component.exports